export default __webpack_public_path__ + "static/media/UKNumberPlate.22820c6f.ttf";